<div class="bg">
  <section class="section">
    <h1 class="landing-page-headline">Clever Educate</h1>
    <p class="paragraph-text">Die modulare Plattform für Lehrende und Lernende.</p>
    <button mat-raised-button class="login-button" color="primary" (click)="login()">Login</button>
  </section>
</div>
